import { Component } from 'preact'
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'
import Icon from '@insided/deprecated-preact-components/assets'
import Button from '@insided/control/uikit/Button'
import EditRoleModal from '@insided/deprecated-control/UserOverview/BulkActions/EditRoleModal'
import { assignRoles, removeRoles } from '@insided/deprecated-control/UserOverview/BulkActions/api'
import { UserData } from '@insided/deprecated-control/UserOverview/DataSource'
import { Role } from '@insided/deprecated-control/UserOverview/Columns'
import tracker from '../../../components/tracker/publish'

interface EditRoleProps extends BulkActionComponentProps {
  customRoles: Role[]
  source: string
}

interface State {
  isModalOpen: boolean
  selectedItems: Role[]
}

class EditRole extends Component<EditRoleProps, State> {
  constructor(props: EditRoleProps) {
    super(props)

    this.state = {
      isModalOpen: false,
      selectedItems: []
    }
  }

  onItemCheck = (roleToAdd: Role) => this.setState(({ selectedItems }) => ({
    selectedItems: [...selectedItems, roleToAdd]
  }))

  onItemUncheck = (roleToRemove: Role) => this.setState(({ selectedItems }) => ({
    selectedItems: selectedItems.filter(role => role.id !== roleToRemove.id)
  }))

  render() {
    const { numberOfSelectedItems, performBulkAction, customRoles, source } = this.props
    const { isModalOpen, selectedItems } = this.state

    return (
      <div>
        <Button
          title={
            <div>
              <Icon icon='userRole' size={16} />
              Edit custom role
            </div>
          }
          size='medium'
          data-qa='bulk-edit-roles'
          variant='secondary'
          onClick={() => this.setState({ isModalOpen: true })}
        />
        <EditRoleModal
          numberOfSelectedItems={numberOfSelectedItems}
          isOpen={isModalOpen}
          selectedItems={selectedItems}
          customRoles={customRoles}
          onSubmit={(isAssigning) =>
            performBulkAction({
              onClick: async (users: UserData[]) => {
                const userIds = users.map(user => user.user_id)
                const roleIds = selectedItems.map(role => role.id)
                const response = isAssigning
                  ? await assignRoles(userIds, roleIds)
                  : await removeRoles(userIds, roleIds)

                tracker.trackEvent('userevent', {
                  type: 'User bulk action applied',
                  bulk_action_title: `${isAssigning ? 'Assign' : 'Remove'} Role`,
                  number_of_selected_users: users.length,
                  source
                })

                return response
              },
              successMessage: `You've ${isAssigning ? 'assigned the custom roles to' : 'removed the custom roles from'} ${numberOfSelectedItems} ${numberOfSelectedItems === 1 ? 'user' : 'users'}.`
            })}
          onClose={() => this.setState({ isModalOpen: false })}
          onItemCheck={this.onItemCheck}
          onItemUncheck={this.onItemUncheck}
        />
      </div>
    )
  }
}

export default EditRole
